import axios from 'axios';
import { notification } from 'antd';
import { getCookie } from '@/utils/app/storage';
import { apiConfig, EnumAPIKey } from '@/constants/app/api';

// import { store } from 'app/store';

const apiAuthen = {
  [EnumAPIKey.API_VENDOR]: null,
  [EnumAPIKey.API_BASE]: () => typeof localStorage !== 'undefined' ? localStorage.getItem('apiAccessToken') : '',
  [EnumAPIKey.API_TOUR]: () => typeof localStorage !== 'undefined' ? localStorage.getItem('apiAccessToken') : '',
  [EnumAPIKey.API_CUSTOMER]: () => getCookie('token'),
  [EnumAPIKey.API_HOTEL]: () => typeof localStorage !== 'undefined' ? localStorage.getItem('apiAccessToken') : '',
  [EnumAPIKey.API_STATIC]: null,
};

const codeMessage: any = {
  200: 'OK',
  201: 'Created',
  202: 'Accepted',
  204: 'No Content',
  400: 'Bad request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  406: 'Not Acceptable',
  410: 'Gone',
  422: 'Unprocessable Entity',
  500: 'Internal Server Error',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
};
const UNAUTHORIZED_ERROR_TEXT = 'Access Token Expired';

const baseAxios = (apiKey: any) => {
  // const accessToken = JSON.parse(localStorage.getItem('auth') || '{}')?.token
  let headers: any = {
    'Content-Type': 'multipart/form-data'
  };

  const takerToken = apiAuthen[apiKey]
  let accessToken = null

  if (takerToken) {
    accessToken = takerToken()
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  };

  let axiosInstance = axios.create({
    baseURL: apiConfig[apiKey] || apiConfig[EnumAPIKey.API_BASE],
    headers: headers,
    timeout: 2 * 60 * 1000
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      if (config.data) {
        const haveFile = Object.values(config.data).some(
          (e: any) => e && e.toString() === '[object File]'
        )
        if (haveFile) {
          config.headers['Content-Type'] = 'multipart/form-data ; charset=UTF-8'
        }
      }

      return config
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      if (typeof response.data?.errorCode === 'number' && response.data?.errorCode != 0) {
        return Promise.reject(response.data)
      }
      if (response.data?.data !== undefined && response.data?.data !== null && typeof response.data.data === 'object') {
        // Arrays must stay arrays — object spread turns [a,b] into {0:a,1:b} and breaks .length loops
        // (filter-options, sort-options, etc.).
        if (Array.isArray(response.data.data)) {
          return Promise.resolve(response.data.data)
        }
        const payload = { ...response.data.data }
        const attachRootFields = response.config.attachRootFields
        if (attachRootFields?.length) {
          for (const field of attachRootFields) {
            if (response.data[field] !== undefined) {
              payload[field] = response.data[field]
            }
          }
        }
        return Promise.resolve(payload)
      }
      return Promise.resolve(response.data);
    },
    handleError,
  );
  return axiosInstance;
}

const showErrMessage = (message: string) => false; //notification.error({ message: <span style={{ whiteSpace: 'pre-wrap' }}>{message}</span> });

const redirectToNotFound = () => {
  if (typeof window === 'undefined') return
  if (window.location.pathname === '/404') return
  window.location.replace('/404')
}

const handleError = (error: any) => {
  const status = error.response?.status || 500;

  if (status === 404) {
    // Avoid redirecting for every API 404 across the app.
    // This is mainly for SEO slug landing pages like /ve-may-bay/[seoSlug].
    if (typeof window !== 'undefined' && window.location.pathname.startsWith('/ve-may-bay/')) {
      redirectToNotFound()
    }
  }

  if (status === 400 && error.response?.data?.message === 'Invalid Token!') {
    if (typeof window !== 'undefined') {
      window.location.href = `/refresh-token?redirect=${window.location.pathname}&${window.location?.search?.replace('?', '')}`
    }
  }

  if (
    status === 401
    // && !!localStorage.getItem('auth')
  ) {
    // Clear all previous notifications
    notification.destroy();
    showErrMessage(UNAUTHORIZED_ERROR_TEXT);
    localStorage.clear()
    window.location.reload()
    // store.dispatch<any>(logOut());
  } else {
    // @ts-ignore
    const stt: number = Object.keys(codeMessage).includes(`${status}`) ? status : 404;
    if (typeof error?.response?.data?.detail_msg === 'string' || error?.response?.data?.detail_msg?.message?.length) {
      if (typeof error?.response?.data?.detail_msg === 'string') {
        showErrMessage(error.response.data.detail_msg.message[0]);
      } else {
        showErrMessage(error.response.data.detail_msg.message[0]);
      }

    } else {
      showErrMessage(codeMessage[stt]);
    }
  }

  if (error.response && error.response.data) {
    return Promise.reject({ ...error.response.data })
  } else {
    return Promise.reject({
      error: true,
      message: 'Error Code 100: No response error from server',
      statusCode:
        error && error.request && error.request.status
          ? error.request.status
          : '1899'
    })
  }
};

export default baseAxios;
